import React, { useState } from "react";
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import axios from "axios";
import ShippedContainerSlider from "../components/ShippedContainerSlider";
import RoundedTable, {
  TABLE_CELL_TYPES,
} from "../components/table-component/RoundedTable";
import SectionDivider from "../components/SectionDivider";
import { useTranslation } from "react-i18next";
import PageWrapper from "../components/PageWrapper";
import useLanguage from "../utils/useLanguage";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker; // Set the worker source

const PdfAnalyzer = () => {
  const [pdfFile, setPdfFile] = useState(null);
  const [result, setResult] = useState(null);
  const { currentDirection } = useLanguage();

  const { t } = useTranslation("general");

  const tableTitles = [
    {
      value: "invoiceNumber",
    },
    {
      value: "customerName",
    },
    {
      value: "totalAmount",
    },
    {
      value: "invoiceType",
    },
    {
      value: "invoiceDate",
    },
    {
      value: "createdBy",
    },
    {
      value: "buttons",
    },
  ];

  const data = [
    {
      id: "INV12345",
      Customer: { name: "John Doe" },
      finalAmount: 250.75,
      invoiceType: "sale",
      date: "2024-03-12T10:30:00Z",
      User: { username: "johnd_admin" },
    },
    {
      id: "INV67890",
      Customer: { name: "Jane Smith" },
      finalAmount: 180.5,
      invoiceType: "purchase",
      date: "2024-03-10T15:20:00Z",
      User: { username: "janes_manager" },
    },
    {
      id: "INV54321",
      Customer: { name: "Michael Johnson" },
      finalAmount: 320.0,
      invoiceType: "refund",
      date: "2024-03-05T08:45:00Z",
      User: { username: "michael_finance" },
    },
  ];

  const tableRows = data?.map((invoice) => [
    {
      value: invoice?.id,
      type: TABLE_CELL_TYPES.LINK,
      to: `/itemInvoice/${invoice.id}`,
      eclipseText: true,
    },
    {
      value: invoice?.Customer?.name,
      type: TABLE_CELL_TYPES.TEXT,
      eclipseText: true,
    },
    {
      value: invoice?.finalAmount,
      type: TABLE_CELL_TYPES.MONEY,
    },
    {
      value: t(invoice?.invoiceType),
      type: TABLE_CELL_TYPES.TEXT,
    },
    {
      value: new Date(invoice?.date).toISOString().split("T")[0],
      type: TABLE_CELL_TYPES.DATE,
    },
    {
      value: invoice?.User?.username,
      type: TABLE_CELL_TYPES.TEXT,
    },
    {
      value: <button>Click here</button>,
      type: TABLE_CELL_TYPES.ELEMENT,
    },
  ]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPdfFile(file);
      setResult(null);
    }
  };

  const testWebsite = async (url) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/test-url?url=${url}`
      );
    } catch (err) {
      console.error("Failed to check the website");
    }
  };

  const analyzePdf = () => {
    if (!pdfFile) {
      return;
    }

    const reader = new FileReader();
    reader.onload = async () => {
      const typedArray = new Uint8Array(reader.result);
      const loadingTask = pdfjsLib.getDocument(typedArray);

      loadingTask.promise
        .then((pdf) => {
          let pageCount = pdf.numPages;
          let textContent = "";

          const pagePromises = [];
          for (let i = 1; i <= pageCount; i++) {
            pagePromises.push(
              pdf.getPage(i).then((page) => {
                return page.getTextContent().then((text) => {
                  textContent +=
                    text.items.map((item) => item.str).join(" ") + " ";
                });
              })
            );
          }

          Promise.all(pagePromises).then(async () => {
            const word = "company";
            const regex = new RegExp(`\\b${word}\\b`, "gi");
            const matches = textContent.match(regex);
            const count = matches ? matches.length : 0;

            // Find websites using regex
            const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
            const urls = textContent.match(urlRegex) || [
              "https://www.google.iq",
            ];
            const urlStatuses = await Promise.all(
              urls.map(async (url) => ({
                url,
                status: await testWebsite(url),
              }))
            );

            setResult(
              <>
                <p>
                  {count > 0
                    ? `The word "company" was found ${count} time(s).`
                    : 'The word "company" was not found.'}
                </p>
                {urls.length > 0 ? (
                  <div>
                    <h3>Website Analysis:</h3>
                    <ul>
                      {urlStatuses.map(({ url, status }, index) => (
                        <li key={index}>
                          {url} - {status}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <p>No websites found in the PDF.</p>
                )}
              </>
            );
          });
        })
        .catch((error) => {
          console.error("Error processing PDF: ", error);
          setResult("Error processing PDF.");
        });
    };

    reader.readAsArrayBuffer(pdfFile);
  };

  return (
    <div className="e-container">
      <PageWrapper
          style={{ direction: currentDirection }}
          title={t("organizations")}
          withBackButton
      >
        <h1>PDF Analyzer</h1>
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
        />
        <button onClick={analyzePdf} disabled={!pdfFile}>
          Analyze file
        </button>
        {result && <div>{result}</div>}
      </PageWrapper>
      __________________
      <ShippedContainerSlider />
      <SectionDivider title="This is a table" />
      <RoundedTable
        titles={tableTitles}
        rows={tableRows}
        // pagination={pagination}
        // setPagination={setPagination}
        withCheckbox
      />
    </div>
  );
};

export default PdfAnalyzer;
